module.exports = __webpack_public_path__ + "static/media/icon-chevon-down.509ff5aa.svg";